import { useEffect, useState } from "react";
import { getNotificationsService } from "../api/services";
import { useRequestError } from "../hooks/useRequestError";
import type { NotificationModel } from "../types/models";
import { getTimeAgo } from "../utils/date";
import { getNotificationCopy } from "../utils/notificationCopy";

export const AlertsPage = () => {
  const { handleRequestError } = useRequestError();
  const [notifications, setNotifications] = useState<NotificationModel[]>([]);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const res = await getNotificationsService({ limit: 50, offset: 0 });
      setNotifications(res.result_list || []);
    } catch (error) {
      handleRequestError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div className="page">
      <header className="page-header">
        <h1>Notifications</h1>
        <button type="button" className="btn btn-secondary" onClick={load}>
          Refresh
        </button>
      </header>
      {loading ? <div className="spinner" /> : null}
      {!loading && notifications.length === 0 ? (
        <div className="empty-state">No alerts yet.</div>
      ) : (
        <div className="card-list">
          {notifications.map((item) => {
            const copy = getNotificationCopy(item);
            const timeAgo = getTimeAgo(item.created_at);
            return (
              <div
                key={item.id}
                className={`panel notification-card tone-${copy.tone}`}
              >
                <div className="row-between">
                  <strong>{copy.title}</strong>
                  {timeAgo ? <span className="muted">{timeAgo}</span> : null}
                </div>
                <p className="muted">{copy.description}</p>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
